import styled from "@emotion/styled"
import { useTranslation } from "react-i18next";

import {
  usePackageManagerVersionRequest,
  usePurchaseManagerVersionRequest,
  useChargebeeWebhookVersionRequest,
} from "@selfserve/react-common-data";
import { StyledText } from "@selfserve/react-ui";

import { AdminSpinner } from "../ui/admin-spinner";

const StyledAdminVersionsText = styled(StyledText)(
  ({ theme }: { theme?: any }) => ({
    marginBottom: theme?.spacing(1),
  })
);

export const AdminVersions = () => {
  const { t } = useTranslation();
  const {
    data: { data: packageManagerVersion } = {},
    isLoading: isPackageManagerLoading,
  } = usePackageManagerVersionRequest();
  const {
    data: { data: purchaseManagerVersion } = {},
    isLoading: isPurchaseManagerLoading,
  } = usePurchaseManagerVersionRequest();
  const {
    data: { data: chargebeeWebhookVersion } = {},
    isLoading: isChargebeeWebhookLoading,
  } = useChargebeeWebhookVersionRequest();
  const isLoading = (
    isPackageManagerLoading ||
    isPurchaseManagerLoading ||
    isChargebeeWebhookLoading
  );

  return (
    <>
      <StyledAdminVersionsText>
        {`${t('common.package-manager-version')} - ${packageManagerVersion || '_'}`}
      </StyledAdminVersionsText>
      <StyledAdminVersionsText>
        {`${t('common.purchase-manager-version')} - ${purchaseManagerVersion || '_'}`}
      </StyledAdminVersionsText>
      <StyledAdminVersionsText>
        {`${t('common.chargebee-webhook-version')} - ${chargebeeWebhookVersion || '_'}`}
      </StyledAdminVersionsText>
      <AdminSpinner loading={isLoading} fullScreen />
    </>
  );
};
